import React, { useState, useEffect } from 'react';

const Countdown = ({ date, onComplete }: any) => {
    const calculateTimeLeft = () => {
        const difference = date - new Date().getTime();
        if (difference > 0) {
            const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((difference / 1000 / 60) % 60);
            const seconds = Math.floor((difference / 1000) % 60);
            return {
                hours: hours < 10 ? `0${hours}` : hours,
                minutes: minutes < 10 ? `0${minutes}` : minutes,
                seconds: seconds < 10 ? `0${seconds}` : seconds,
            };
        } else {
            return { hours: '00', minutes: '00', seconds: '00' };
        }
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            const newTimeLeft = calculateTimeLeft();
            setTimeLeft(newTimeLeft);

            // Nếu thời gian kết thúc, gọi hàm onComplete và xóa interval
            if (newTimeLeft.hours === '00' && newTimeLeft.minutes === '00' && newTimeLeft.seconds === '00') {
                clearInterval(timer);
                if (onComplete) {
                    onComplete();
                }
            }
        }, 1000);

        return () => clearInterval(timer); // Clear interval khi unmount
    }, [date, onComplete]);

    return (
        <div>
            {timeLeft.hours}:{timeLeft.minutes}:{timeLeft.seconds}
        </div>
    );
};

export default Countdown;
